<template>
  <div class="menu-main">
    <div @click="back">戻る</div>
    <div class="column-wrap">
      <p>名前</p>
      <div class="content">
        <input type="text" v-model="name" @change="updateMenuName">
      </div>
    </div>
    <div class="column-wrap">
      <p>値段</p>
      <div class="content">
        <input type="number" v-model="price" @change="updateMenuPrice">
      </div>
    </div>
    <div class="column-wrap">
      <p>説明文</p>
      <div class="content">
        <input type="text" v-model="ex" @change="updateMenuEx">
      </div>
    </div>
  </div>
</template>

<script>
import { userDB, shopDB } from "../firebaseInit";

export default {
  name: "MenuDetail",
  data() {
    return {
      menu: null,
      name: null,
      price: null,
      ex: null
    };
  },
  mounted() {
    const mid = this.$route.params.mid;
    this.menu = this.getMenu(mid);
    this.name = this.menu.name;
    this.price = this.menu.price;
    this.ex = this.menu.ex;
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    getMenu(mid) {
      return this.menus[mid];
    },
    getName() {
      if (this.menu) {
        return this.menu.name;
      } else {
        return "";
      }
    },
    getPrice() {
      if (this.menu) {
        return this.menu.price;
      } else {
        return "";
      }
    },
    getEx() {
      if (this.menu) {
        return this.menu.ex;
      } else {
        return "";
      }
    },
    getDisplayText(t) {
      if (t === 0) {
        return "非表示";
      } else {
        return "表示";
      }
    },
    updateMenuName(r) {
      this.$store.dispatch("updateMenuName", {
        mid: this.menu.id,
        name: this.name
      });
    },
    updateMenuPrice(r) {
      if (Number.isInteger(this.price)) {
        this.$store.dispatch("updateMenuPrice", {
          mid: this.menu.id,
          price: this.price
        });
      } else {
        alert("数字(整数)を入力してください");
        this.price = this.menu.price;
      }
    },
    updateMenuEx(r) {
      this.$store.dispatch("updateMenuEx", {
        mid: this.menu.id,
        ex: this.ex
      });
    }
  },
  computed: {
    menus() {
      return this.$store.state.menus;
    },
    menuCategory() {
      let types = [];
      const menus = this.menus;
      for (let mid in menus) {
        const menu = menus[mid];
        const type = menu.type;
        if (type) {
          if (!types.includes(type)) {
            types.push(type);
          }
        }
      }
      return types;
    },
    nums() {
      let current_nums = [{ value: "-", index: 0 }];
      for (let i = 1; i < 100; i++) {
        current_nums.push({ value: `${i}`, index: i });
      }

      return current_nums;
    }
  }
};
</script>

<style scoped>
.menu-main {
  /* background-color: rgb(241, 241, 241); */
}

.column-wrap {
  background-color: white;
  border-bottom: 1px solid #a0a0a0;
  text-align: left;
  padding: 10px 0;
  margin: 0 20px;
}

.column-wrap p:first-child {
  color: lightgray;
}

.column-wrap .content {
  margin-top: 20px;
}

.column-wrap input {
  font-size: large;
}
</style>